// src/components/CommentItem.js

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BsHeart, BsHeartFill } from 'react-icons/bs';
import { MdDelete } from 'react-icons/md';
import api from '../utils/axios';
import moment from 'moment-timezone';

const CommentItem = ({ comment, onCommentDelete, onCommentLike }) => {
    const [isLiked, setIsLiked] = useState(comment.liked);
    const [likeCount, setLikeCount] = useState(comment.like_count);

    const handleCommentLike = async () => {
        try {
            await api.post(`/video-posts/comments/${comment.id}/like`);
            setIsLiked(!isLiked);
            setLikeCount(isLiked ? likeCount - 1 : likeCount + 1);
            onCommentLike && onCommentLike(comment.id, !isLiked);
        } catch (error) {
            console.error('Error liking comment:', error);
        }
    };

    const handleDeleteComment = async () => {
        try {
            await api.delete(`/video-posts/comments/${comment.id}`);
            onCommentDelete && onCommentDelete(comment.id);
        } catch (error) {
            console.error('Error deleting comment:', error);
        }
    };

    // Ensure both IDs are numbers
    const currentUserId = Number(localStorage.getItem('userId'));
    const commentUserId = Number(comment.user_id);

    console.log('Current User ID:', currentUserId);
    console.log('Comment User ID:', commentUserId);

    return (
        <div className="comment">
            <Link to={`/users/${comment.user_id}`} className="comment-user-info">
                <img
                    src={comment.profile_picture || "https://via.placeholder.com/40"}
                    alt={comment.display_name}
                    className="comment-avatar"
                />
                <div className="user-details">
                    <span className="user-name">{comment.display_name}</span>
                    {comment.company_name && (
                        <span className="user-company">{comment.company_name}</span>
                    )}
                </div>
            </Link>

            <div className="comment-content">
                <p className="comment-text">{comment.comment}</p>
                <div className="comment-footer">
                    <div className="comment-actions">
                        <button
                            className={`like-btn ${isLiked ? 'liked' : ''}`}
                            onClick={handleCommentLike}
                        >
                            {isLiked ? <BsHeartFill /> : <BsHeart />}
                            <span>{likeCount}</span>
                        </button>
                        {currentUserId === commentUserId && (
                            <button
                                className="delete-comment-btn"
                                onClick={handleDeleteComment}
                                title="Delete Comment"
                            >
                                <MdDelete />
                            </button>
                        )}
                    </div>
                    <span className="comment-time">
                        {moment(comment.created_at).tz('America/Toronto').fromNow()}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default CommentItem;